import { ArrowUpRight } from 'lucide-react';
import { openAssetByKey } from '../../utils/openAssetByKey';

// S3 keys are relative paths without a leading slash (e.g. "profiles/abc.jpg")
// Relative app paths ("/agents?email=...") and full URLs ("https://...") go through as-is
const isAssetKey = (url: string) => !url.startsWith('http') && !url.startsWith('/');

const UrlPreview = ({ label, url }: { label?: string; url?: string }) => (
  <div className="flex flex-col gap-2">
    {label && <p className="text-xs text-gray-500">{label}</p>}
    {url ? (
      !isAssetKey(url) ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center text-blue-600 hover:underline text-xs font-medium space-x-1"
        >
          <span>Open Link</span>
          <ArrowUpRight size={14} />
        </a>
      ) : (
        <button
          type="button"
          onClick={() => openAssetByKey(url)}
          className="inline-flex items-center text-blue-600 hover:underline text-xs font-medium space-x-1"
        >
          <span>Open Link</span>
          <ArrowUpRight size={14} />
        </button>
      )
    ) : (
      <p className="text-sm text-gray-800">-</p>
    )}
  </div>
);

export default UrlPreview;
